$(document).ready(function () {
//sliders
    (function () {
        var slidesPerView = $(document).outerWidth() <= 768 ? 1 : 2;
        var swiperResponses = new Swiper('.slider-review .swiper-slider-container', {
            slidesPerView: slidesPerView,
            spaceBetween: 20,
            loop: true,
            nextButton: '.next-btn',
            prevButton: '.prev-btn',
            autoHeight: true,
        });
    })();

    (function () {
        var swiperConvert = new Swiper('.cover .swiper-container', {
            slidesPerView: 1,
            loop: true,
            nextButton: '.cover .next-btn',
            prevButton: '.cover .prev-btn',
            autoHeight: true,
        });
        $('.images-list a').click(function (e) {
            e.preventDefault();
            swiperConvert.slideTo($('.images-list a').index($(this)) + 1);
        });
    })();

    (function () {
        var swiperConvert = new Swiper('.js-main-slider', {
            slidesPerView: 1,
            loop: true,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
        });
    })();

    (function () {
        var slidesPerView = 3;
        if ($(document).outerWidth() <= 768) {
            slidesPerView = 1;
        } else if ($(document).outerWidth() > 768 && $(document).outerWidth() <= 1024) {
            slidesPerView = 2;
        }
        var slider = new Swiper($('.cart-slider'), {
            slidesPerView: slidesPerView,
            spaceBetween: 20,
            loop: true,
            nextButton: $('.next-btn'),
            prevButton: $('.prev-btn')
        });
    })();
    if ($(".images-list").length > 0) {
        $('.images-list').niceScroll({
            cursorwidth: 2,
            cursoropacitymin: 1,
            cursorcolor: '#959595',
            cursorborder: 'none',
            cursorborderradius: 4,
            autohidemode: 'false',
            directionlockdeadzone: 6,
            cursorfixedheight: 70,
        });
    }
});
